import login from './login';

export default {
  language: 'en-GB',
  country: 'gb',
  name: 'English',
  embeddedLocale: login,
};
